import type { ContentLocale } from './contentLocale';

export const SUPPORT_EMAIL = 'contact@exam-copilot.com';
export const LEGAL_SITE = 'https://exam-copilot.com';

export function affiliationShort(locale: ContentLocale): string {
  return locale === 'en'
    ? 'Unofficial practice questions — not affiliated with, endorsed by, or an official exam of AWS, Microsoft, Google, Cisco, PMI or any certifying body.'
    : 'Questions de préparation non officielles — non affiliées à AWS, Microsoft, Google, Cisco, PMI ni à aucun organisme certificateur, et non cautionnées par eux.';
}

export function affiliationExamLine(locale: ContentLocale): string {
  return locale === 'en'
    ? 'Unofficial practice material. Not affiliated with or endorsed by the certifying organization. This is not an official exam.'
    : 'Questions de préparation non officielles / non affiliées. Ceci n’est pas un examen officiel.';
}
